import React, { useCallback, useEffect, useState } from 'react';
import { Footer, StatusView } from '../../common';
import { Heading, NestedRadio } from '../../../../../../UiKit';
import { reasonModel } from '../../../../../../api';
import { EmptyState } from '../../../../../commons';
import { InvalidSearchImg } from '../../../../../../images/images';

export const AddonAction = ({
  addOnActions = null,
  orderId = null,
  reasonId = null,
  sendFormData = () => {},
}) => {
  const [isEnabled, setIsEnabled] = useState(
    !!addOnActions?.submit_button?.is_enabled,
  );
  const [addOnActionsInput, setAddOnActionsInput] = useState({});
  const [addOnActionResponse, setAddOnActionResponse] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [err, setErr] = useState(false);

  const submitForm = useCallback(() => {
    setIsDisabled(true);
    const { submit_button } = addOnActions;
    const { url } = submit_button;

    const data = {
      ...addOnActionsInput,
      order_id: orderId,
      meta: addOnActions?.meta,
    };

    setAddOnActionsInput(data);

    return reasonModel
      .sendFormData(url, reasonId, data)
      .then((response) => {
        if (!response) return null;
        setAddOnActionResponse(response);
        setIsDisabled(false);
        return response;
      })
      .catch((err) => {
        console.log('err', err);
        setErr(true);
        setIsDisabled(false);
      });
  }, [orderId, addOnActions, sendFormData]);

  const handleRadioChange = useCallback(
    (item, data) => {
      if (data?.input?.key) {
        const updatedInput = {
          ...addOnActionsInput,
          [data.input.key]: item.value,
        };
        setAddOnActionsInput({ ...updatedInput });
      }
    },
    [addOnActions],
  );

  if (!addOnActions) return null;

  let btnBgColor = !isEnabled ? '#B5B5B5' : '#4B9B42';

  if (err) {
    return (
      <EmptyState
        img={InvalidSearchImg}
        imageWidth='10rem'
        heading={'Something went wrong'}
      />
    );
  }

  if (addOnActionResponse)
    return (
      <StatusView
        response={addOnActionResponse}
        imgHeight={'10vh'}
        imgWidth={'10vh'}
      />
    );

  return (
    <div className='tw-flex tw-flex-col tw-w-full tw-h-full tw-items-center tw-justify-center tw-gap-4'>
      {addOnActions.image ? (
        <div className='img' style={{ width: '6vh', height: '8vh' }}>
          <img src={addOnActions.image} alt='' />
        </div>
      ) : null}
      {addOnActions.texts
        ? addOnActions.texts.map((message, index) => {
            return (
              <React.Fragment key={index}>
                <p
                  className='text'
                  style={{
                    fontWeight: message.type,
                    color: message.color,
                    textAlign: message.align,
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  {message.text}
                </p>
                {message.break && <br></br>}
              </React.Fragment>
            );
          })
        : null}
      {addOnActions?.radio?.source?.length > 0 ? (
        <React.Fragment>
          <div className='tw-flex tw-flex-col tw-w-full tw-gap-2'>
            {addOnActions.radio.title && (
              <Heading title={addOnActions.radio.title} />
            )}
            <NestedRadio
              data={addOnActions.radio}
              items={addOnActions.radio.source}
              selectOption={handleRadioChange}
              onRadioInputChange={handleRadioChange}
            />
          </div>
        </React.Fragment>
      ) : null}
      <Footer
        issueInfo={addOnActions}
        submitBtnTitle={addOnActions?.submit_button.text}
        btnBgColor={btnBgColor}
        sendFormData={submitForm}
        isDisabled={!addOnActionsInput || isDisabled}
      />
    </div>
  );
};
